<abi-spinner *ngIf="busyLoading"></abi-spinner>
<div *ngIf="!busyLoading && !checklistData">
    <p>
        No relevant Checklist(s) available
    </p>
</div>
<div *ngIf="!busyLoading && checklistData && checklistAnswers" [formGroup]="form">
    <div class="table-responsive">
        <table class="table table-sm mb-0">
            <thead class="thead-light">
                <tr>
                    <th translate="Checklist.Question" class="w-50"></th>
                    <th translate="Checklist.Answer" class="w-35"></th>
                    <!-- <th translate="Checklist.Notes" class="w-20"></th> -->
                    <!-- <th translate="Checklist.Result" class="text-center w-10"></th> -->
                    <th class="text-right w-15"></th>
                </tr>
            </thead>
            <tbody formArrayName="answers">
                <ng-container *ngFor="let question of answers.controls; let i = index"
                    [formGroupName]="i">
                    <tr [ngClass]="{ 'table-active': question.enabled }">

                        <!-- QUESTION -->
                        <td class="align-middle"
                            [innerHTML]="safeAnswer(checklistData.questions[i].text)"
                        ></td>
                        <!-- ANSWER -->
                        <td class="align-middle">
                            <ng-container  *ngIf="question.enabled; else answerLbl">

                                <ng-container *ngIf="checklistData.questions[i].typeId === 'TEXT'">
                                    <input
                                        type="text"
                                        formControlName="answer"
                                        class="form-control"
                                        placeholder="Enter answer"
                                    />
                                </ng-container>

                            <ng-container *ngIf="checklistData.questions[i].typeId === 'NUMBER'">
                                <input
                                    type="number"
                                    formControlName="answer"
                                    class="form-control"
                                    placeholder="Enter answer"
                                />
                            </ng-container>

                                <ng-container *ngIf="checklistData.questions[i].typeId === 'CHECKBOX'">
                                    <div
                                        class="btn-group"
                                        role="group"
                                        aria-label="Choose answer"
                                    >
                                        <button
                                            [abiToggle]="'CHECKED' === question.value.answer"
                                            (click)="toggleAnswer(i, 'CHECKED')"
                                            [disabled]="false">
                                        </button>

                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checklistData.questions[i].typeId === 'RADIO'">
                                    <div
                                        class="btn-group"
                                        role="group"
                                        aria-label="Choose answer"
                                    >
                                        <button
                                            *ngFor="let opt of checklistData.questions[i].options"
                                            type="button"
                                            class="btn btn-outline-primary"
                                            [class.active]="opt.value === question.value.answer"
                                            [accessKey]="opt.description[0]"
                                            (click)="selectRadio(i, opt.value)"
                                        >
                                            {{ opt.description || opt.value }}
                                        </button>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checklistData.questions[i].typeId === 'DROPDOWN'">
                                    <div
                                        class="btn-group"
                                        role="group"
                                        aria-label="Choose answer"
                                    >
                                        <select formControlName="answer" name="select-option">
                                            <option
                                                *ngFor="let opt of checklistData.questions[i].options"
                                                [value]="opt.value"
                                            >
                                                {{ opt.description || opt.value }}
                                            </option>
                                        </select>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checklistData.questions[i].typeId === 'FILE'">
                                    <div
                                        class="btn-group"
                                        role="group"
                                        aria-label="Choose answer"
                                    >
                                        <ng-container *ngIf="busyUploading; else canUpload">
                                            <abi-spinner *ngIf="true" position="relative" [diameter]="30" [stroke]="3"></abi-spinner>
                                        </ng-container>
                                        <ng-template #canUpload>
                                            <abi-file-button
                                                [buttonDisabled]="!question.enabled"
                                                (selected)="uploadFile(i, $event)"
                                                [loading]="false"
                                                btnClass="btn btn-primary mr-2"
                                                faClass="fas fa-upload"
                                                [defaultDescription]="checklistData.questions[i].questionId + '-{Checklist}'"
                                                > {{ question.value.answer ? 'Add/Replace' : 'Attachment.Upload' | translate }} </abi-file-button>

                                            <ng-template *ngIf="!!question.value.answer" [ngTemplateOutlet]="viewAttachment" [ngTemplateOutletContext]="{$implicit: question.value.answer}"></ng-template>
                                        </ng-template>
                                    </div>
                                </ng-container>

                            </ng-container>
                            <!-- NOTE: add option to Upload file against a specific checklist item (for back referencing to this specific item)-->
                            <ng-template #answerLbl>
                                <ng-container *ngIf="checklistData.questions[i].typeId === 'TEXT'">
                                    {{ question.getRawValue().answer }}
                                </ng-container>

                            <ng-container *ngIf="checklistData.questions[i].typeId === 'NUMBER'">
                                {{ question.getRawValue().answer }}
                            </ng-container>

                                <ng-container *ngIf="checklistData.questions[i].typeId === 'CHECKBOX'">
                                    <ng-container *ngIf="question.value.answer === 'CHECKED'">
                                        <button
                                            btnClass="p-0"
                                            baseClass="btn btn-text "
                                            [abiToggle]="true"
                                            [disabled]="true">
                                        </button>
                                    </ng-container>
                                    <ng-container *ngIf="question.value.answer !== 'CHECKED'">
                                        {{ question.getRawValue().answer }}
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="checklistData.questions[i].typeId === 'RADIO' || checklistData.questions[i].typeId === 'DROPDOWN'">
                                    <ng-container *ngIf="!!question.value.answer">
                                        {{ question.getRawValue().answer }}
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="checklistData.questions[i].typeId === 'FILE'">
                                    <ng-container *ngIf="!!question.value.answer">
                                        <ng-template [ngTemplateOutlet]="viewAttachment" [ngTemplateOutletContext]="{$implicit: question.value.answer}"></ng-template>
                                    </ng-container>
                                </ng-container>
                            </ng-template>
                        </td>

                        <!-- <td class="">
                            <abi-checklist-comment>
                                <textarea [disabled]="!question.enabled" formControlName="notes" noBootstrap class="form-control" rows="3"></textarea>
                            </abi-checklist-comment>

                            <i>{{ question.value.notes | truncate }}</i>
                        </td> -->

                        <!-- <td class="text-center">
                            <ng-container *ngIf="answerGood(i)">
                                <i class="fas fa-check text-success"></i>
                            </ng-container>
                        </td> -->

                        <td class="text-right">
                            <button [disabled]="form.pending || busyUploading" *ngIf="canGoBack(i)" type="button" class="btn btn-outline-primary" (click)="clearAnswer(i)">Back</button>
                            <button [disabled]="form.pending || busyUploading" *ngIf="!isLast(i) && currentQuestion === checklistData.questions[i].questionId" type="button" class="btn btn-primary ml-1" (click)="saveAndNext(i)">Save</button>
                            <button [disabled]="form.pending || busyUploading" *ngIf="isLast(i) && currentQuestion === checklistData.questions[i].questionId" type="button" class="btn btn-primary ml-1" (click)="complete(i)">Save & Complete</button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>

<ng-template #viewAttachment let-attachment>
    <button class="btn btn-primary" (click)="onViewAttachment(attachment)" type="button">View attachment</button>
</ng-template>
